import React, { useEffect, useState } from 'react';
import ImageComponent from 'atoms/Image';
import { useSelector } from 'react-redux';
import { getFullImagePath, getPriceWithExtractingJsonHelper } from 'common/utilities/utils';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

const OccassionItemsComponent = props => {
  const {
    occassionOrder,
    checkProductAvailabity,
    additemToUnfavourite,
    addItemToFavourite,
    availableProductPrice,
    getPrice,
  } = props;
  const tenantReducer = useSelector(data => data.tenantReducer || null);
  const {
    tenantId,
    currencySymbol,
    addHope,
    carryBag,
    currencyConversionFactor,
    componentOptions: { web: { global: { showPriceWithTax = false } = {} } = {} } = {},
  } = tenantReducer;
  const favouriteItems = useSelector(data => data.profileReducer?.favouriteItems || null);
  const customerId = useSelector(data => data.profileReducer?.basic.id || null);
  const { flatResponse: { itemMapById = {} } = {} } = useSelector(({ menuReducer }) => menuReducer) ?? {};
  const [foodLineItem, setFoodLineItem] = useState([]);
  const { heartIcon_inactive_red, heartIcon_activeFavourite, Error } = IMAGE_PATH;
  const { items } = occassionOrder;
  useEffect(() => {
    let filteredFoodLine = items.filter(foodItem => foodItem?.name !== addHope && foodItem?.name !== carryBag);
    setFoodLineItem(filteredFoodLine);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [occassionOrder]);

  return (
    <React.Fragment>
      {foodLineItem.map((ordereditem, index) => {
        const isOccasionProductAvailable = checkProductAvailabity(ordereditem.id);
        const catalogueData = itemMapById?.[ordereditem.id];
        const cataloguePrice = getPrice(availableProductPrice(ordereditem.id));
        const differencePrice = getPrice(ordereditem.priceWithTax) - cataloguePrice;
        const getTogglabelPrice = getPriceWithExtractingJsonHelper(
          catalogueData?.availability[0].price,
          catalogueData?.additionalProperties,
          currencyConversionFactor,
          showPriceWithTax,
        );

        return (
          <section
            className={
              isOccasionProductAvailable
                ? 'account-accordian-details-section'
                : 'account-accordian-details-section product-unavailable'
            }
          >
            <div className='option-section option-section-fav-menu'>
              <ImageComponent
                className='favourite-order-img'
                srcFile={getFullImagePath(ordereditem.imageName, tenantReducer)}
                alt={'No-Image'}
                defaultPath={getFullImagePath(null, tenantReducer, true)}
              />
              <div className='favourite-order-details'>
                <span className='order-item-name'>{ordereditem.name}</span>
                <div className='fav-order-details'>
                  {ordereditem.modGroups &&
                    ordereditem.modGroups.map(modDetails => {
                      return (
                        <span>
                          {modDetails &&
                            modDetails.modifiersDetails.map(modifiers => {
                              return (
                                <span>
                                  {' '}
                                  {modifiers.quantity}x {modifiers.name}
                                </span>
                              );
                            })}
                        </span>
                      );
                    })}
                </div>
                {isOccasionProductAvailable && (
                  <div className='occasion-item-price'>
                    {differencePrice !== 0 ? (
                      <div>
                        <span className='prev-price'>
                          {currencySymbol}
                          {getPrice(ordereditem.price)?.toFixed(2)}
                        </span>
                        {'  '}
                        <span className='new-current-price'>
                          {currencySymbol}
                          {getTogglabelPrice}
                        </span>
                      </div>
                    ) : (
                      <span className='current-price'>
                        {currencySymbol}
                        {getTogglabelPrice}
                      </span>
                    )}
                  </div>
                )}
                {!isOccasionProductAvailable && (
                  <div className='occasion-item-price-unavailable'>
                    <img src={Error} alt='Item Unavailable' /> {`Unavailable`}
                  </div>
                )}
              </div>
              <div className='occasion-fav-item'>
                <img
                  src={
                    Array.isArray(favouriteItems) && favouriteItems.find(el => el?.id === ordereditem?.id)
                      ? heartIcon_activeFavourite
                      : heartIcon_inactive_red
                  }
                  alt={''}
                  className='pdp-product-save'
                  data-testid={`save-product-handler-${index}`}
                  onClick={() =>
                    Array.isArray(favouriteItems) && favouriteItems.find(el => el?.id === ordereditem?.id)
                      ? additemToUnfavourite(tenantId, customerId, ordereditem.id)
                      : addItemToFavourite(tenantId, ordereditem, ordereditem?.availability, customerId)
                  }
                />
              </div>
            </div>
          </section>
        );
      })}
    </React.Fragment>
  );
};

export default OccassionItemsComponent;
